import { register } from "register-service-worker";

declare global {
  interface Window {
    __PWA_REGISTRATION__?: ServiceWorkerRegistration;
  }
}

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(import.meta.env.QUASAR_SERVICE_WORKER_FILE, {
  ready(registration) {
    window.__PWA_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('pwa-ready', { detail: registration }));
  },

  registered(registration) {
    window.__PWA_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('pwa-registered', { detail: registration }));
  },

  cached(registration) {
    window.__PWA_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('pwa-cached', { detail: registration }));
  },

  updatefound(registration) {
    window.__PWA_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('pwa-updatefound', { detail: registration }));
  },

  updated(registration) {
    window.__PWA_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('pwa-updated', { detail: registration }));
  },

  offline() {
    window.dispatchEvent(new CustomEvent('pwa-offline'));
  },

  error(err) {
    console.error('Error during service worker registration:', err);
    window.dispatchEvent(new CustomEvent('pwa-error', { detail: err }));
  }
});
